import { Link } from "react-router-dom";
import { Seo } from "../components/site/Seo";

export default function NotFound() {
  return (
    <section className="bg-white" data-testid="not-found-page">
      <Seo title="Page not found" description="The page you are looking for could not be found." noindex />
      <div className="container-x py-32">
        <p className="eyebrow">404</p>
        <h1 className="h-display mt-6">This page could not be found.</h1>
        <p className="lead mt-6 max-w-xl">The link may be out of date, or the page may have moved.</p>
        <div className="mt-10 flex flex-wrap gap-4">
          <Link to="/" className="btn-primary" data-testid="not-found-home-link">Return home</Link>
          <Link to="/contact" className="btn-secondary" data-testid="not-found-contact-link">Contact us</Link>
        </div>
      </div>
    </section>
  );
}
